import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import request from '../../../../../network/request'
import { reportGio } from '../../../../../utils/gioReport'
import styles from './index.module.scss'

export type VehicleCheckReportProps = {
  journeyOrderNo?: string
  vin?: string
}

const VehicleCheckReport: React.FC<VehicleCheckReportProps> = ({ journeyOrderNo }) => {
  const history = useHistory()
  const [hasReport, setHasReport] = useState<boolean>(false)
  const [pendingCount, setPendingCount] = useState<number>(0)

  useEffect(() => {
    if (journeyOrderNo) {
      request('module/repair/vehicleCheckReport/banner', { journeyOrderNo }, 'POST')
        .then((res: any) => {
          setHasReport(!!res?.hasReport)
          setPendingCount(res?.pendingCount || 0)
        })
        .catch(() => {})
    }
  }, [journeyOrderNo])

  const handleClick = () => {
    if (journeyOrderNo) {
      reportGio({
        eventId: 'APP_P11184_B003',
        type: 'CLICK',
        name: '点击车辆检查报告',
        content_type: '点击了服务记录页面的车辆报告',
      })
      history.push(`/vehicle/report?journeyOrderNo=${journeyOrderNo}`)
    }
  }

  if (!hasReport) {
    return null
  }

  return (
    <div className={styles.container} onClick={handleClick}>
      <div className={styles.title}>车辆检查报告</div>
      {!!pendingCount && (
        <div className={styles.abnormal}>共{pendingCount}项异常</div>
      )}
      <div className={styles.linkText}>点击查看完整报告&gt;&gt;</div>
    </div>
  )
}

export default VehicleCheckReport
